var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"default-layout"}},[_c('navbar-component'),_c('sidebar-component'),_c('div',{attrs:{"id":"main"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }